import type { SocialLink } from '@/components/social/types'

export const FACEBOOK = 'facebook'
export const GOOGLE = 'google'
export const NEXT_DOOR = 'nextDoor'

export const SOCIAL_LINKS: SocialLink[] = [ FACEBOOK, GOOGLE, NEXT_DOOR ]
export default { SOCIAL_LINKS, FACEBOOK, GOOGLE, NEXT_DOOR }
